import { fetchTermByID, fetchTerms } from '../../actions/terms-preview.actions';

const mapStateToThis = ({ termsPreview: { list, selectedTerm } }) => ({
  list,
  selectedTerm,
});

const mapDispatchToThis = {
  fetchTermByID,
  fetchTerms
};

@Inject('$ngRedux')
export class TermsPageController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.fetchTerms();
  }

  $onDestroy() {
    this.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/modules/terms-preview/components/terms-page/terms-page-controller.js